import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import { mapState } from 'vuex';
import MyOrganisationSettings from '~/components/settings/MyOrganisationSettings';
import CompanySecuritySettings from '~/components/settings/CompanySecuritySettings';
import APIClientManagement from '~/components/settings/APIClientManagement';
import AlertsSettings from '~/components/settings/AlertsSettings';
import MyReports from '~/components/settings/MyReports';
import ClientUsersSettings from '~/components/settings/ClientUsersSettings';
import SubscriptionSettings from '~/components/subscription/SubscriptionSettings.vue';
import AccountingSettings from '~/components/accounting/AccountingSettings.vue';
import LoadingOverlay from '~/components/LoadingOverlay';
export default {
  name: "CompanySettings",
  components: {
    LoadingOverlay: LoadingOverlay,
    MyOrganisationSettings: MyOrganisationSettings,
    CompanySecuritySettings: CompanySecuritySettings,
    AlertsSettings: AlertsSettings,
    ClientUsersSettings: ClientUsersSettings,
    SubscriptionSettings: SubscriptionSettings,
    AccountingSettings: AccountingSettings,
    MyReports: MyReports,
    APIClientManagement: APIClientManagement
  },
  middleware: function middleware(_ref) {
    var $gates = _ref.$gates,
      store = _ref.store,
      route = _ref.route,
      redirect = _ref.redirect;
    var isClient = store.getters["permissions/userIsClient"];
    if (!isClient) {
      redirect("/");
    }
  },
  data: function data() {
    return {
      subscriptionModalDisplay: false,
      subscriptionTemporary: null,
      loadingRequest: false,
      tabs: {
        '#profile-organisation': {
          name: "pages.settings.my_organisation",
          icon: "mdi-sitemap-outline",
          componentType: "my-organisation-settings",
          ref: "organisation",
          update: "company_information",
          permissions: this.$gates.hasAnyRole("client|master|kam|masteradmin|enfantadmin|kamclient")
        },
        '#security': {
          name: "pages.settings.company_security",
          icon: "mdi-security",
          componentType: "company-security-settings",
          value: this.$store.state.settings.me.security,
          ref: "security",
          update: "security",
          permissions: true
        },
        '#client-users': {
          name: "pages.settings.client_users",
          icon: "mdi-account-group",
          componentType: "client-users-settings",
          ref: "clientUsersSettings",
          permissions: this.$gates.hasAnyRole("master|kam|masteradmin|enfantadmin|kamclient")
        },
        '#screenings_configuration': {
          name: "pages.settings.screenings_configuration",
          icon: "mdi-office-building-cog-outline",
          componentType: "alerts-settings",
          ref: "default_dossiers_options",
          value: this.$store.state.settings.me.default_dossiers_options,
          update: "default_dossiers_options",
          permissions: "defaultDossiersSettingsDisplay",
          withAlertSwitch: true
        },
        '#client-pricing': {
          name: "pages.settings.change_subscription",
          icon: "mdi-format-list-checks",
          componentType: "subscription-settings",
          ref: "subscription",
          events: {
            input: this.changeSubscription
          },
          update: "subscription",
          permissions: "subscriptionDisplay"
        },
        '#report-configuration': {
          name: "pages.settings.reports.report_configuration",
          icon: "mdi-file-chart-outline",
          componentType: "my-reports",
          ref: "report_configuration",
          update: "report_settings",
          permissions: "reportsDisplay"
        },
        '#api-settings': {
          name: "pages.settings.api_settings",
          icon: "mdi-connection",
          componentType: "APIClientManagement",
          ref: "api_settings",
          update: "",
          permissions: "apiEnabled"
        }
      }
    };
  },
  fetch: function fetch() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.$store.dispatch("formData/getSettings");
          case 2:
            _context.next = 4;
            return _this.$store.dispatch("settings/getMe");
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  head: function head() {
    return {
      title: this.$t("pages.layout.settings")
    };
  },
  computed: _objectSpread(_objectSpread({
    selectedTab: {
      get: function get() {
        return this.$route.hash || "#profile-organisation";
      },
      set: function set() {}
    }
  }, mapState({
    formDataSettings: function formDataSettings(state) {
      return state.formData.settings;
    },
    subscriptionDisplay: function subscriptionDisplay(state) {
      var _state$settings$me;
      return !!((_state$settings$me = state.settings.me) !== null && _state$settings$me !== void 0 && _state$settings$me.subscription) && Object.keys(state.settings.me.subscription).length !== 0;
    },
    reportsDisplay: function reportsDisplay(state) {
      var _state$settings$me2, _state$settings$me$re;
      return ((_state$settings$me2 = state.settings.me) === null || _state$settings$me2 === void 0 ? void 0 : _state$settings$me2.report_settings) && ((_state$settings$me$re = state.settings.me.report_settings) === null || _state$settings$me$re === void 0 ? void 0 : _state$settings$me$re.can_update);
    },
    defaultDossiersSettingsDisplay: function defaultDossiersSettingsDisplay(state) {
      var _state$settings$me3;
      return !!((_state$settings$me3 = state.settings.me) !== null && _state$settings$me3 !== void 0 && _state$settings$me3.default_dossiers_options) && Object.keys(state.settings.me.default_dossiers_options).length !== 0;
    },
    apiEnabled: function apiEnabled(state) {
      return state.settings.me.company_information.api_enabled;
    },
    error: function error(state) {
      return state.settings.error;
    }
  })), {}, {
    isMaster: function isMaster() {
      return this.$store.getters["permissions/userIsMaster"];
    },
    filteredTabs: function filteredTabs() {
      var tabs = {};
      for (var keyTabs in this.tabs) {
        var tab = this.tabs[keyTabs];
        if (Object.prototype.hasOwnProperty.call(tab, "permissions")) {
          var permissions = tab.permissions;
          if (permissions === true || this.isAFunction(permissions)) {
            tabs = _objectSpread(_objectSpread({}, tabs), {}, _defineProperty({}, keyTabs, _objectSpread({}, tab)));
          }
        }
      }
      return tabs;
    }
  }),
  watch: {
    isMaster: function isMaster(newCount, oldCount) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.$store.dispatch("settings/getMe");
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    this.unsubscribe = this.$store.subscribeAction({
      after: this.subscribeUpdateSettings
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.unsubscribe();
  },
  mounted: function mounted() {},
  methods: {
    updateProfile: function updateProfile() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var updateTypeData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              updateTypeData = _this3.tabs[_this3.selectedTab].update;
              _context3.next = 3;
              return _this3.$store.dispatch("settings/updateSettings", {
                updateTypeData: updateTypeData
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    subscribeUpdateSettings: function subscribeUpdateSettings(action, state) {
      if (action.type === "settings/updateSettings") {
        if (this.error !== null) {
          this.catchUpdateProfile(this.error._data);
        }
      }
    },
    catchUpdateProfile: function catchUpdateProfile(err) {
      var currentRef = this.tabs[this.selectedTab].ref;
      var updateTypeData = this.tabs[this.selectedTab].update;
      console.log("error catchUpdateProfile", currentRef, err[updateTypeData]);
      this.setErrors("currentComponent".concat(currentRef), err[updateTypeData]);
    },
    changeSubscription: function changeSubscription(_ref2) {
      var name = _ref2.name;
      if (!!name) {
        this.subscriptionTemporary = name;
        this.subscriptionModalDisplay = true;
      }
    },
    closeSubscription: function closeSubscription(_ref3) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _ref3$confirm, confirm;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _ref3$confirm = _ref3.confirm, confirm = _ref3$confirm === void 0 ? false : _ref3$confirm;
              if (!_this4.loadingRequest) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return");
            case 3:
              if (!confirm) {
                _context4.next = 8;
                break;
              }
              _this4.loadingRequest = true;
              _context4.next = 7;
              return _this4.configSubscription();
            case 7:
              _this4.loadingRequest = false;
            case 8:
              _this4.subscriptionTemporary = null;
              _this4.subscriptionModalDisplay = false;
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    configSubscription: function configSubscription() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this5.$store.commit("settings/SET_VALUE", {
                namespace: "subscription",
                key: "name",
                value: _this5.subscriptionTemporary
              });
            case 2:
              _context5.next = 4;
              return _this5.updateProfile({
                messageSuccess: "pages.settings.subscription_success"
              });
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    setErrors: function setErrors(ref, err) {
      if (!!err) {
        var _this$$refs$ref, _this$$refs$ref$;
        this === null || this === void 0 ? void 0 : (_this$$refs$ref = this.$refs[ref]) === null || _this$$refs$ref === void 0 ? void 0 : (_this$$refs$ref$ = _this$$refs$ref[0]) === null || _this$$refs$ref$ === void 0 ? void 0 : _this$$refs$ref$.setErrors(err);
      }
    },
    isAFunction: function isAFunction(arg) {
      return _typeof(arg) === "string" && !!this[arg];
    }
  }
};